import { render, staticRenderFns } from "./ViberCampaignCreateThirdStep.vue?vue&type=template&id=572ce0d6&scoped=true&"
import script from "./ViberCampaignCreateThirdStep.vue?vue&type=script&lang=js&"
export * from "./ViberCampaignCreateThirdStep.vue?vue&type=script&lang=js&"
import style0 from "./ViberCampaignCreateThirdStep.vue?vue&type=style&index=0&id=572ce0d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572ce0d6",
  null
  
)

export default component.exports